import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const Placeholder = styled.div<{ $visible: boolean }>`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 100%;
	display: ${({ $visible }) => ($visible ? 'flex' : 'none')};
	align-items: center;
	justify-content: center;
	gap: 10px;
	pointer-events: none;
	opacity: 0.5;
	z-index: 1;

	img {
		width: 14px;
		height: 14px;
		object-fit: contain;
		transition: filter 0.3s ease;
	}

	${Text} {
		color: rgba(255, 255, 255, 0.5);
		transition: color 0.3s ease;
	}
`;

const Wrapper = styled.div`
	position: relative;
	width: 100%;

	&:focus-within ${Placeholder} {
		display: none;
	}

	&:hover ${Placeholder} {
		img {
			filter: invert(1);
		}

		${Text} {
			color: rgba(0, 0, 0, 0.5);
		}
	}
`;

export { Placeholder, Wrapper };
